/* eslint react/no-string-refs: "off" */

import React from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';

import dialogLoader from '../utilities/dialogLoader';
import { validateByJoi } from '../utilities/validation';
import {
  JSDropdownSingleSelect,
  JSDropdownMultiSelect,
} from '../components/JSDropdown';
import {
  FormList,
  FormListItem,
  FormListSubHeader,
  FormElement,
} from '../components/CommonFormComponents';
import { CompanyBranchDropdown } from '../components/dropdowns/single/CompanyBranch';
import { RadioButtonIcon } from '../components/icons/RadioButtonIcon';
import Information from '../components/modals/common/Information';
import FieldTreeAdminWorkerManager from './FieldTreeAdminWorkerManager';
import * as api from '../services/FieldTree';
import regex from '../utilities/validateRegex';
import FieldTreeGeneralWorkerManager from './FieldTreeGeneralWorkerManager';
import FieldTreeJobAndPositionRegisterDialog from './FieldTreeJobAndPositionRegisterDialog';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { messageUtility } from '../utilities/messageUtility';
import { ManagerDropdownSelector } from './dropdowns/ManagerDropdownSelector';
import { CompanyService } from '../services/Companies';
import { FieldContractorUserService } from '../services/FieldContractorUsers';
import {
  CSV_TYPE,
  CALL_FROM_PAGE,
  APPROVAL_STATUS_FIELDTREE,
  USER_ROLES,
  INTEGRATE_USER_COMMON_ERROR_MESSAGE,
  INTEGRATE_USER_SUCCESS_TITLE,
  INTEGRATE_USER_SUCCESS_MESSAGE,
  AGENCY_REGISTRATION_APPLICATION_PAGE,
  USER_BOX_STATUS,
  ZENDESK_URL_GUIDE,
} from '../utilities/constants';
import { deleteControlCodeFromEvent } from '../utilities/stringUtil';
import {
  isPartnerCompanyRoleId,
  isPartnerRoleId,
} from '../utilities/roleUtility';
import {
  HEAD_OFFICE_OPTION,
  PartnerCompanyBranchDropdown,
} from './PartnerCompanyBranchDropdown';
import { LoginUserGroupsService } from '../services/LoginUserGroups';
import { ConfirmExistedEmailDialog } from './modals/ConfirmExistedEmailDialog';
import { ConfirmIntegrateUserDialog } from './modals/ConfirmIntegrateUserDialog';
import { IntegrateError } from './modals/IntegrateError';
import EventManager, { EventType } from '../utilities/EventManager';
import { Confirmation } from './modals/common';
import { Description } from './Description';
import masterSlideLoader from '../utilities/masterSlideLoader';
import PartnerCompanyBranchService from '../services/PartnerCompanyBranch';
import { FormSelect } from './FormSelect';
import { addPartnerCompanySucessDialog } from '../styles/organisms/add-partner-company-success-dialog.scss';

/**
 * 登録完了
 */
export class submitSuccess extends React.Component {
  render() {
    return (
      <Information
        visible={true}
        onClose={this.props.dialog.callback.done}
        title='ユーザー登録完了'
        message='ユーザーの登録が完了しました。'
        buttonText={messageUtility.getMessage('I-000-017')}
        multilineText={true}
      />
    );
  }
}

/**
 * 更新完了
 */
export class patchSuccess extends React.Component {
  render() {
    return (
      <Information
        visible={true}
        onClose={this.props.dialog.callback.done}
        title='ユーザー更新完了'
        message='ユーザーの更新が完了しました。'
        buttonText={messageUtility.getMessage('I-000-017')}
        multilineText={true}
      />
    );
  }
}

/**
 * 登録失敗
 */
export class submitError extends React.Component {
  errorMessage(errorMessage) {
    return (
      <div className='dialog-sm__body'>
        <p>
          <span className='text--muted'>{errorMessage}</span>
        </p>
      </div>
    );
  }

  render() {
    return (
      <div
        className='dialog-sm dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-sm__header'>
          <span className='dialog-sm__title'>登録失敗</span>
        </div>
        {this.errorMessage(this.props.dialog.message)}
        <div className='dialog-sm__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            了解
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 登録失敗メッセージ付き
 */
export class submitErrorMessage extends React.Component {
  render() {
    return (
      <Information
        visible={true}
        title={this.props.dialog.title || '登録失敗'}
        message={this.props.dialog.message}
        buttonText={messageUtility.getMessage('I-000-017')}
        onClose={this.props.dialog.callback.done}
        rootClassName={this.props.dialog.className || ''}
        multilineText={true}
      />
    );
  }
}

/**
 * 登録失敗メッセージ付き
 */
export class ErrorMessageNoTitle extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__body'>
          <p>
            <span className='text--muted'>{this.props.dialog.message}</span>
          </p>
        </div>
        <div className='dialog-md__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            了解
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 電話重複エラー
 */
export class TelError extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>エラー</span>
        </div>
        <div className='dialog-md__body'>
          <p>
            <span className='text--muted'>
              この電話番号はすでに登録されているため使用できません
            </span>
          </p>
        </div>
        <div className='dialog-md__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            了解
          </button>
        </div>
      </div>
    );
  }
}

/**
 * メール重複エラー
 */
export class MailError extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>
            {messageUtility.getMessage('E-001-402')}
          </span>
        </div>
        <div className='dialog-md__body text-left'>
          <p>{this.props.dialog.message}</p>
        </div>
        <div className='dialog-md__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            {messageUtility.getMessage('I-000-017')}
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 承認依頼完了
 */
export class ConfirmApprovedOffer extends React.Component {
  render() {
    return (
      <div
        className='dialog-sm dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-sm__header'>
          <span className='dialog-sm__title'>承認依頼完了</span>
        </div>
        <div className='dialog-sm__body'>
          <p>
            <span className='text--muted'>
              元請けからの承認を
              <br />
              お待ちください
            </span>
          </p>
        </div>
        <div className='dialog-sm__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            了解
          </button>
        </div>
      </div>
    );
  }
}

/**
 * x件の承認完了
 */
export class ConfirmApprovedMulti extends React.Component {
  render() {
    return (
      <div
        className='dialog-sm dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-sm__header'>
          <span className='dialog-sm__title'>承認完了</span>
        </div>
        <div className='dialog-sm__body'>
          <p>
            <span className='text--muted'>
              {this.props.dialog.state.number}件の承認が完了しました
            </span>
          </p>
        </div>
        <div className='dialog-sm__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              dialogLoader.close();
            }}
          >
            了解
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 承認依頼の取り消し
 */
export class ConfirmApprovedCancel extends React.Component {
  render() {
    return (
      <div
        className='dialog-sm dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-sm__header'>
          <span className='dialog-sm__title'>承認依頼取り消し</span>
        </div>
        <div className='dialog-sm__body'>
          <p>
            <span className='text--muted'>
              元請けへの承認依頼を
              <br />
              取り消しました
            </span>
          </p>
        </div>
        <div className='dialog-sm__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            了解
          </button>
        </div>
      </div>
    );
  }
}

/**
 * CSV出力
 * TODO:一覧のロードとアクションを実装
 */
export class CSVExport extends React.Component {
  render() {
    return (
      <div className='dialog-sm dialog--modal'>
        <div className='dialog-sm__header'>
          <span className='dialog-sm__title'>出力するデータを選択</span>
        </div>
        <div className='dialog-sm__body-min'>
          <div className='dialog-form'>
            <div className='dialog-form__item' style={{ padding: '0' }}>
              <div className='dialog-form__element --col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'>
                <div className='form-element__element'>
                  <PartnerCompanyList
                    // eslint-disable-next-line no-unused-vars
                    callback={(...args) => {
                      /*console.log(" select " , args );*/
                    }}
                    fieldId={this.props.dialog.state.fieldId}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='dialog-sm__footer'>
          <button
            className='btn-fixedsize'
            onClick={e => {
              this.props.dialog.callback.export(e, { id: 1 });
            }}
          >
            出力する
          </button>
          <button
            className='btn-fixedsize--sub'
            onClick={e => {
              this.props.dialog.callback.close(e);
            }}
          >
            戻る
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 協力会社CSV出力
 */
export class CSVExportPartnerCompany extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      csvExportManager: CSV_TYPE.USER_LIST,
      companyBranchIds: [],
      isOpen: false,
    };
  }

  changeCsv(type) {
    this.setState({ csvExportManager: type });
  }

  csvCallback = (e, key, value) => {
    this.setState({ companyBranchIds: value });
  };

  outputCsv = () => {
    this.props.dialog.callback.csvDownloadPreparation(
      this.state.csvExportManager,
      this.state.companyBranchIds
    );
  };

  changeDialogHeight = isOpen => {
    this.setState({
      isOpen,
    });
  };

  render() {
    const { csvExportManager, isOpen } = this.state;
    const { dialog } = this.props;

    return (
      <div className='dialog-md dialog--modal CSVExportPartnerCompanyDialog'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>出力するデータを選択</span>
        </div>
        <div className='dialog-md__contents'>
          <div
            className={`CSVExportPartnerCompanyDialog__body ${
              isOpen ? 'CSVExportPartnerCompanyDialog__body--large' : ''
            }`}
          >
            <div className='form-list-radio__item'>
              <label className='radio'>
                <input
                  type='radio'
                  onChange={() => this.changeCsv(CSV_TYPE.USER_LIST)}
                  checked={csvExportManager === CSV_TYPE.USER_LIST}
                />
                <RadioButtonIcon className='icon--2x' />
                <span>管理者・職長一覧</span>
              </label>
            </div>
            <span className='dialog-md-notice'>
              ※現場内の全ての協力会社管理者、職長を出力します。
            </span>
            <div className='form-list-radio__item'>
              <label className='radio'>
                <input
                  type='radio'
                  onChange={() => this.changeCsv(CSV_TYPE.PARTNER_LIST)}
                  checked={csvExportManager === CSV_TYPE.PARTNER_LIST}
                />
                <RadioButtonIcon className='icon--2x' />
                <span>協力会社一覧</span>
              </label>
            </div>
            {csvExportManager === CSV_TYPE.PARTNER_LIST && (
              <div className='CSVExportPartnerCompanyDialog__dropdown set-width-dropdown'>
                <PartnerCompanyCSVList
                  callback={this.csvCallback}
                  changeDialogHeight={this.changeDialogHeight}
                  fieldId={dialog.state.fieldId}
                  InfinityScrollEnable={true}
                  enable={csvExportManager === CSV_TYPE.PARTNER_LIST}
                />
                <span className='dialog-md-notice'>
                  ※未選択の場合は現場内の全ての協力会社を出力します。
                </span>
              </div>
            )}
          </div>
          <div className='dialog-md__footer-horizontal'>
            <button
              className='btn-fixedsize--sub'
              onClick={dialog.callback.close}
            >
              戻る
            </button>
            <button className='btn-fixedsize' onClick={this.outputCsv}>
              出力する
            </button>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * 職長CSV出力
 */
export const CSVExportPartnerForeman = props => (
  <div className='dialog-md dialog--modal'>
    <div className='dialog-md__header'>
      <span className='dialog-md__title'>現場内管理者・職長一覧をCSV出力</span>
    </div>
    <br />
    <div className='dialog-md__footer-horizontal'>
      <button
        className='btn-fixedsize--sub'
        onClick={props.dialog.callback.close}
      >
        戻る
      </button>
      <button
        className='btn-fixedsize'
        onClick={props.dialog.callback.csvDownloadPreparation}
      >
        出力する
      </button>
    </div>
  </div>
);

/**
 * 管理者CSV出力
 */
export const CSVExportPartnerAdmin = props => (
  <div className='dialog-md dialog--modal'>
    <div className='dialog-md__header'>
      <span className='dialog-md__title'>現場監督をCSV出力</span>
    </div>
    <br />
    <div className='dialog-md__footer-horizontal'>
      <button
        className='btn-fixedsize--sub'
        onClick={props.dialog.callback.close}
      >
        戻る
      </button>
      <button
        className='btn-fixedsize'
        onClick={props.dialog.callback.csvDownloadPreparation}
      >
        出力する
      </button>
    </div>
  </div>
);

/**
 * 作業を終了させますか？
 */
export class ConfirmFinishWork extends React.Component {
  render() {
    return (
      <div className='dialog-md dialog--modal'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>作業を終了させますか？</span>
        </div>
        <div className='dialog-md__body text-left'>
          <p>{messageUtility.getMessage('I-001-426')}</p>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={e => {
              this.props.dialog.callback.back(e);
            }}
          >
            {messageUtility.getMessage('I-000-017')}
          </button>
          <button
            className='btn-fixedsize--negative '
            onClick={e => {
              this.props.dialog.callback.done(e);
            }}
          >
            作業終了
          </button>
        </div>
      </div>
    );
  }
}

/**
 * ステータス変更
 */
export class ConfirmEditStatus extends React.Component {
  constructor(props) {
    super(props);
    this.callbacks = props.callbacks;
    this.state = {
      value: this.props.dialog.value,
    };
  }

  onChange = e => {
    this.setState({ value: Number(e.target.value) });
  };

  isChangeStatus = () => {
    return this.state.value !== this.props.dialog.value;
  };

  handleSubmit = () => {
    return this.isChangeStatus()
      ? this.props.dialog.callback.save(this.state.value)
      : null;
  };

  renderContent = () => {
    return (
      <FormList>
        <FormElement>
          <FormSelect value={this.state.value} onChange={this.onChange}>
            {_.map(
              USER_BOX_STATUS,
              ({ value, text }) =>
                // 停止中ステータスには変更できないため除外
                value !== USER_BOX_STATUS.blocked.value && (
                  <option value={value} key={value}>
                    {text}
                  </option>
                )
            )}
          </FormSelect>
        </FormElement>
      </FormList>
    );
  };
  render() {
    return (
      <Confirmation
        visible={true}
        title='ステータス'
        message={this.renderContent()}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        confirmButtonText='変更する'
        onCancel={this.props.dialog.callback.back}
        rootClassName='ConfirmEditStatusDialog'
        onConfirm={this.handleSubmit}
        disabledConfirmButton={!this.isChangeStatus()}
        multilineText={true}
      />
    );
  }
}

/**
 * 作業終了を取り消しますか？
 */
export class ConfirmCancelFinishWork extends React.Component {
  render() {
    const { callback, isLastChild } = this.props.dialog;
    return (
      <div className='dialog-md dialog--wide dialog--modal ConfirmCancelFinishWork'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>作業終了を取り消しますか？</span>
        </div>
        <div className='dialog-md__body text-left'>
          <p>{messageUtility.getMessage('I-001-427')}</p>
        </div>
        {!isLastChild && (
          <div className='ConfirmCancelFinishWork__footer'>
            <button
              className='btn-fixedsize--effective ConfirmCancelFinishWork__footer__btn-confirm'
              onClick={() => {
                callback.done();
              }}
            >
              {messageUtility.getMessage('I-001-428')}
            </button>
            <button
              className='btn-fixedsize--effective ConfirmCancelFinishWork__footer__btn-confirm'
              onClick={() => {
                callback.done(true);
              }}
            >
              {messageUtility.getMessage('I-001-429')}
            </button>
          </div>
        )}
        <div className='dialog-md__footer-horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              callback.back();
            }}
          >
            {messageUtility.getMessage('I-000-008')}
          </button>
          {isLastChild && (
            <button
              className='btn-fixedsize--effective'
              onClick={() => {
                callback.done();
              }}
            >
              {messageUtility.getMessage('I-001-430')}
            </button>
          )}
        </div>
      </div>
    );
  }
}

/**
 * 協力会社名ユーザー新規作成
 */
export class PartnerCOmpanyNewUser extends React.Component {
  render() {
    return (
      <div className='dialog-md dialog--modal'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>
            {'協力会社名'}ユーザー新規作成
          </span>
        </div>
        <div className='dialog-md__body flex justify-center'>
          <div style='width: 236px;font-size: 13px;'>
            ユーザーの新規作成は「検索して追加」で表示されない場合のみデータの重複に十分注意して行ってください。
          </div>
        </div>
        <div className='dialog-md__footer'>
          <button className='btn-fixedsize'>管理者招待</button>
          <button className='btn-fixedsize sys-slide-partner-company-edit-user-open'>
            職長新規作成
          </button>
          <button className='btn-fixedsize--sub sys-modal-dialog-partner-company-new-user-close'>
            戻る
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 新しいグループを追加
 */
export class AddNewGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertshow: false,
    };
  }

  async Save() {
    if (!this.refs.group_name.value.length) {
      this.setState({ alertshow: true });
      return;
    }

    //TODO:ここでグループを新規登録
    //this.refs.group_name
    const param = {
      name: this.refs.group_name.value,
    };
    const data = await api.NewGroupAdd(
      SessionStorageService.getFieldId(),
      param
    );

    if (data) {
      //成功
      this.props.dialog.callback.done(data);
      dialogLoader.close();
    } else {
      console.log('通信エラー');
    }
  }

  render() {
    return (
      <div className='dialog-sm dialog--modal'>
        <div className='dialog-sm__header'>
          <span className='dialog-sm__title'>新しいグループを追加</span>
        </div>
        <div className='dialog-sm__body'>
          <div className='dialog-form'>
            <div className='dialog-form__item' style={{ padding: '0 4px' }}>
              <div className='dialog-form__element' style={{ width: '100%' }}>
                <input
                  onFocus={() => {
                    this.setState({ alertshow: false });
                  }}
                  type='text'
                  className=' --col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                  ref='group_name'
                />
                <div
                  style={
                    this.state.alertshow
                      ? { display: 'block' }
                      : { display: 'none' }
                  }
                >
                  <span style={{ color: 'red', fontSize: '10px' }}>
                    {' '}
                    必須です。
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='dialog-sm__footer'>
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              dialogLoader.close();
            }}
          >
            戻る
          </button>
          <button
            className='btn-fixedsize--effective'
            onClick={e => {
              this.Save(e);
            }}
          >
            登録
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 編集画面を閉じる
 */
export class CloseEditView extends React.Component {
  render() {
    return (
      <div className='dialog-md dialog--modal'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>編集画面を閉じる</span>
        </div>
        <div className='dialog-md__body flex justify-center'>
          <div className='text-left'>
            {messageUtility.getMessage('I-000-confirmCloseEditWindow')}
          </div>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              this.props.dialog.callback.close();
            }}
          >
            戻る
          </button>
          <button
            className='btn-fixedsize--negative'
            onClick={() => {
              this.props.dialog.callback.clear();
            }}
          >
            {messageUtility.getMessage('I-000-closeEditWindow')}
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 協力会社を削除しますか？
 */
export const DeletePartnerCompany = ({ dialog }) => (
  <Confirmation
    visible={true}
    message={messageUtility.getMessage('W-000-005')}
    title='現場にアクセスできなくなります'
    confirmButtonText='削除する'
    cancelButtonText={messageUtility.getMessage('I-000-008')}
    onCancel={dialog.callback.back}
    isNegative={true}
    multilineText={true}
    onConfirm={dialog.callback.delete}
    rootClassName='dialog--wide'
  />
);

/**
 * 協力会社ユーザーを削除しますか？
 */
export class DeletePartnerCompanyUser extends React.Component {
  render() {
    return (
      <div className='dialog dialog--modal'>
        <div className='dialog__header'>
          <span className='dialog__title'>ユーザーを削除しますか？</span>
        </div>
        <div className='dialog__body flex justify-center'>
          <div style={{ width: '100%', fontSize: '12px', textAlign: 'center' }}>
            削除したユーザーはこの現場にログインできなくなります。
            <br />
            ※この操作は取り消せません。本当に削除しますか？
          </div>
        </div>
        <div className='dialog__footer-vertical'>
          <button
            className='btn-fixedsize--sub sys-close'
            onClick={() => {
              this.props.dialog.callback.close();
            }}
          >
            戻る
          </button>
          <button
            className='btn-fixedsize--negative sys-delete'
            onClick={() => {
              this.props.dialog.callback.delete();
            }}
          >
            削除する
          </button>
        </div>
      </div>
    );
  }
}

/**
 * @description 協力会社ユーザーが「現場から削除」ボタンを押し、削除できない時に表示されるダイアログ
 * @param message 協力会社が承認待ちか承認待ちか
 */
export class NotAuthorityDelete extends React.Component {
  render() {
    let message = '';
    if (
      this.props.dialog.approval_flag === APPROVAL_STATUS_FIELDTREE.pending.id
    ) {
      message = (
        <React.Fragment>
          現場体制が元請承認待のため失敗しました。
          <br />
          元請承認待の協力会社を現場から削除するには、一次の協力会社管理者のユーザー様にて承認依頼を取り消す必要があります。
          <br />
          <br />
          操作の詳細については
          <a
            className='clickable-text'
            href={ZENDESK_URL_GUIDE.DELETE_TREE_PARTNER_COMPANY}
            target='_blank'
            rel='noreferrer noopener'
          >
            こちら
          </a>
          をご確認ください。
        </React.Fragment>
      );
    } else {
      message = (
        <React.Fragment>
          現場体制が元請に承認されているため失敗しました。
          <br />
          承認済みの協力会社を現場から削除するには、元請のユーザー様にて操作いただく必要があります。
          <br />
          <br />
          現場からの削除については
          <a
            className='clickable-text'
            href={ZENDESK_URL_GUIDE.DELETE_TREE_PARTNER_COMPANY}
            target='_blank'
            rel='noreferrer noopener'
          >
            こちら
          </a>
          から詳細をご確認のうえ、元請のユーザー様に削除をご依頼ください。
        </React.Fragment>
      );
    }
    return (
      <div
        className='dialog dialog--modal'
        style={{ width: '600px', maxWidth: '600px' }}
      >
        <div className='dialog__header'>
          <span className='dialog__title'>失敗しました</span>
        </div>
        <div className='dialog__body'>{message}</div>
        <div className='dialog__footer-vertical'>
          <button
            className='btn-fixedsize--sub sys-close'
            onClick={() => {
              this.props.dialog.callback.close();
            }}
          >
            閉じる
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 削除できません！
 */
export class NotDeletePartnerCompanyUser extends React.Component {
  render() {
    return (
      <div className='dialog dialog--modal'>
        <div className='dialog__header'>
          <span className='dialog__title'>このユーザーを削除できません</span>
        </div>
        <div className='dialog__body flex justify-center'>
          <div style={{ width: '100%', fontSize: '12px', textAlign: 'center' }}>
            {this.props.dialog.message}
          </div>
        </div>
        <div className='dialog__footer-vertical'>
          <button
            className='btn-fixedsize--sub sys-close'
            onClick={() => {
              this.props.dialog.callback.close();
            }}
          >
            戻る
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 元請けユーザーを削除しますか？
 */
export class DeleteConstructorUser extends React.Component {
  renderMessage = () => (
    <React.Fragment>
      <span>
        削除したユーザーはこの現場にログインできなくなります。
        <br />
      </span>
      <span>※この操作は取り消せません。本当に削除しますか？</span>
    </React.Fragment>
  );
  render() {
    return (
      <Confirmation
        visible={true}
        title='削除しますか？'
        message={this.renderMessage()}
        confirmButtonText='削除する'
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        onConfirm={this.props.dialog.callback.delete}
        onCancel={this.props.dialog.callback.close}
        isNegative={true}
        multilineText={true}
      />
    );
  }
}

/**
 * このデータは削除できません
 */
export class NeverDeletePartnerCompany extends React.Component {
  render() {
    return (
      <div className='dialog-md dialog--modal'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>このデータは削除できません</span>
        </div>
        <div className='dialog-md__body flex justify-center'>
          <div
            style={{
              width: '100%',
              fontSize: '13px',
              textAlign: 'center',
              whiteSpace: this.props.dialog.message ? 'pre-line' : '',
            }}
          >
            {this.props.dialog.message ? (
              this.props.dialog.message
            ) : (
              <React.Fragment>
                現場内の登録データに使用されているため削除できません。
                <br />
                ステータスを未使用に切り替えることでデータ登録時に非表示にできます。
              </React.Fragment>
            )}
          </div>
        </div>
        <div className='dialog-md__footer'>
          <button
            className='btn-fixedsize--sub sys-close'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            戻る
          </button>
        </div>
      </div>
    );
  }
}

/**
 * このデータは削除できません（APIエラーメッセージ表示）
 */
export class DeletePartnerCompanyFailure extends React.Component {
  render() {
    const { message, callback } = this.props.dialog;
    return (
      <Information
        visible={true}
        title={messageUtility.getMessage('E-001-308')}
        rootClassName='dialog--wide'
        message={message}
        buttonText={messageUtility.getMessage('I-000-008')}
        multilineText={true}
        onClose={callback.done}
      />
    );
  }
}

/**
 * 現場監督検索ダイアログ
 */
export class ForemanSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      param: {
        company_branch_id: null,
        constructor_user_id: null,
      },
      branch: {},
      searchParams: {},
    };
  }

  setParam(name, id) {
    let _param = { ...this.state.param };
    _param[name] = id;
    this.setState({ param: _param });
  }

  /**
   * 現場監督の選択
   *
   * @memberof SafetyDiaries
   */
  handleSelectorChange = (name, values) => {
    let renew;
    if (_.isEmpty(values)) {
      renew = _.omit(this.state.searchParams, name);
    } else {
      renew = { ...this.state.searchParams, [name]: values };
    }
    this.setState({ searchParams: renew });
  };

  render() {
    const enableSubmit = !this.state.param.constructor_user_id;
    const enableStyle = this.state.param.constructor_user_id
      ? { opacity: '1' }
      : { opacity: '.5' };

    return (
      <div className='dialog-md dialog--modal'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>ユーザー検索</span>
        </div>
        <div className='dialog-md__body'>
          <div className='dialog-form'>
            <div className='dialog-form__item set-width-dropdown'>
              <div className='dialog-form__label --col-xs-5 --col-md-5 --col-lg-5 --col-xl-5'>
                <span className='label'>支店</span>
              </div>
              <div className='dialog-form__element --col-xs-7 --col-md-7 --col-lg-7 --col-xl-7'>
                <div className='form-element'>
                  <div className='form-element__element'>
                    <CompanyBranchDropdown
                      name='company_branch_id'
                      value={_.toNumber(this.state.param.company_branch_id)}
                      set={(setkey, id) => {
                        this.setParam(setkey, _.toString(id));
                        const searchParams = { ...this.state.searchParams };
                        searchParams.contractor_user_id = null;
                        this.setState(
                          {
                            searchParams,
                          },
                          () => {
                            this.setParam('constructor_user_id', null);
                          }
                        );
                      }}
                      setkey='company_branch_id'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='dialog-form__item'>
              <div className='dialog-form__label --col-xs-5 --col-md-5 --col-lg-5 --col-xl-5'>
                <span className='label'>ユーザー名</span>
              </div>
              <div className='dialog-form__element --col-xs-7 --col-md-7 --col-lg-7 --col-xl-7'>
                <div className='form-element'>
                  <div className='form-element__element'>
                    <ManagerDropdownSelector
                      label='ユーザーを選択'
                      multiple={false}
                      selectorName='contractor_user_id'
                      api={params => {
                        delete params.is_limit;
                        return FieldContractorUserService.ForemanList(
                          this.props.dialog.state.fieldId,
                          params
                        );
                      }}
                      apiParams={this.state.param}
                      apiSearchKey='name'
                      selectedValues={
                        this.state.searchParams.contractor_user_id
                          ? [this.state.searchParams.contractor_user_id]
                          : []
                      }
                      keyName='fullname'
                      valueName='id'
                      apiBindDataKey={'user_lists'}
                      onSelect={(name, values) => {
                        this.setParam('constructor_user_id', values);
                        this.handleSelectorChange(name, values);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              this.props.dialog.callback.back();
            }}
          >
            戻る
          </button>
          <button
            className='btn-fixedsize--effective'
            onClick={() => {
              this.props.dialog.callback.submit(this.state.param);
            }}
            disabled={enableSubmit}
            style={enableStyle}
          >
            このユーザーを追加
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 管理者招待成功
 */
export class InviteSuccess extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>管理者招待</span>
        </div>
        <div className='dialog-md__body'>
          <p>
            <span className='text--muted'>招待メールを送信しました。</span>
          </p>
        </div>
        <div className='dialog-md__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            確認
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 管理者招待エラー
 */
export class InviteError extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>管理者招待</span>
        </div>
        <div className='dialog-md__body'>
          <p>
            <span className='text--muted'>
              送信先のメールアドレスが
              <br />
              元請ユーザーとして登録されているため送信できません。
            </span>
          </p>
        </div>
        <div className='dialog-md__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            確認
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 協力会社作業員追加
 */
export class WorkerManager extends FieldTreeAdminWorkerManager {}
export class EnterWorkerManager extends FieldTreeGeneralWorkerManager {}
export class JobAndPositionRegister extends FieldTreeJobAndPositionRegisterDialog {}

/**
 * 協力会社検索ドロップダウン
 */
class PartnerCompanyList extends JSDropdownSingleSelect {
  constructor(props) {
    super(props);
    this.param = {
      name: 'name',
      label: '協力会社',
      apiurl: 'field_tree_id',
    };
  }
}

/**
 * CSV協力会社検索ドロップダウン
 */
class PartnerCompanyCSVList extends JSDropdownMultiSelect {
  constructor(props) {
    super(props);
    this.component;
    this.param = {
      name: 'company_branch_id',
      label: '協力会社',
      apiurl: 'field_tree_id_all_csv',
    };
    this.isOpen = false;
    this.setRef = this.setRef.bind(this);
    document.addEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }

  handleClickOutsideOfComponent = e => {
    if (!(this.myRef && this.myRef.contains(e.target))) {
      this.component.hideDropdown();
    }
  };

  componentDidUpdate() {
    window.removeEventListener('mousedown', this.component.controlEvent);
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }
}

/**
 * CSV元請け管理者検索ドロップダウン
 */
// eslint-disable-next-line no-unused-vars
class PartnerAdminCSVList extends JSDropdownMultiSelect {
  constructor(props) {
    super(props);
    this.component;
    this.param = {
      name: 'user_id',
      label: '現場監督',
      apiurl: 'field_constructor_users_current',
    };
    this.setRef = this.setRef.bind(this);
  }
}

/**
 * 協力会社ユーザー新規作成誤登録防止
 */
export class PartnerUserNewPreDialog extends React.Component {
  render() {
    return (
      <div className='dialog dialog--wide dialog--modal'>
        <div className='dialog__header'>
          <span className='dialog__title'>
            {messageUtility.getMessage('I-000-149')}
          </span>
        </div>
        <div className='dialog__body'>
          <span className='dialog__text-box dialog__text dialog__text--large text--red--primary'>
            {this.props.dialog.state.companyName}
          </span>
          <p className='dialog__text-box dialog__text text--red--primary'>
            {this.props.dialog.state.oneMasterTypeNameCompanyNumber}
            <br />
            {this.props.dialog.state.companyAddress}
          </p>
          <p className='dialog__text-box dialog__text'>
            この会社にユーザーを登録しようとしています。
            <br />
            登録先の会社に間違いがないかご確認のうえ新規登録を行ってください。
          </p>
          {isPartnerRoleId(LocalStorageService.getRoleId()) &&
            SessionStorageService.isCommonPartnerCompany() && (
              <Description>
                <React.Fragment>
                  自身を他社にユーザー登録することはお控えください。
                  <br />
                  下位協力会社の登録情報を編集する必要がある場合には、
                  <span
                    className='clickable-text'
                    onClick={() => {
                      dialogLoader.close();
                      masterSlideLoader.show(
                        AGENCY_REGISTRATION_APPLICATION_PAGE.LIST
                          .COMPONENT_NAME,
                        {
                          state: {},
                        }
                      );
                    }}
                  >
                    こちら
                  </span>
                  から代行登録機能をご利用ください。
                </React.Fragment>
              </Description>
            )}
        </div>
        <div className='dialog__footer dialog__footer--horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={e => {
              this.props.dialog.callback.back(e);
            }}
          >
            {messageUtility.getMessage('I-000-008')}
          </button>
          <button
            className='btn-fixedsize'
            onClick={e => {
              this.props.dialog.callback.new(e);
            }}
          >
            この会社に新規登録
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 協力会社ユーザー新規作成
 */
export class PartnerUserNewDialog extends React.Component {
  render() {
    return (
      <div className='dialog dialog--wide dialog--modal dialog--dialog-partner-user-new'>
        <div className='dialog__header'>
          <span className='dialog__title'>
            {messageUtility.getMessage('I-000-149')}
          </span>
        </div>
        <div className='dialog__body'>
          <div className='dual-panel'>
            <div className='dual-panel__item'>
              <div className='panel'>
                <div className='panel-header'>
                  <div className='button-area'>
                    <div className='button-area-element button-area-element__partner'>
                      <div className='button-area-element__description'>
                        <FormList>
                          <FormListSubHeader
                            title={'協力会社管理者ユーザーを作成'}
                            noMarginTop={true}
                          />
                          <p className='dialog__text-box dialog__text'>
                            作業員などの自社情報の登録・管理、現場体制の登録、各サービスの操作が行えるユーザーです。
                            <br />
                            『Buildee入退場管理』『Buildee労務安全』を利用する現場では必ず1人は現場への招待が必要です。
                          </p>
                        </FormList>
                      </div>
                      <div className='button-area-element__service'>
                        <div className='bold'>主に利用するサービス</div>
                        <br />
                        <div className='logo-title--tyousei' />
                        <br />
                        <div className='logo-title--nyutai' />
                        <br />
                        <div className='logo-title--rouan' />
                      </div>
                      <div className='button-area-element__submit'>
                        <button
                          className='btn-fixedsize'
                          onClick={e => {
                            this.props.dialog.callback.invite(e);
                          }}
                        >
                          管理者招待
                        </button>
                      </div>
                    </div>
                    <div className='button-area-element button-area-element__foreman'>
                      <div className='button-area-element__description'>
                        <FormList>
                          <FormListSubHeader
                            title={'職長ユーザーを作成'}
                            noMarginTop={true}
                          />
                          <p className='dialog__text-box dialog__text'>
                            作業予定など、日々の各種予定を登録するためのユーザーです。
                            <br />
                            稼働中の職長がいないと『Buildee調整会議』で作業予定の登録ができません。
                          </p>
                        </FormList>
                      </div>
                      <div className='button-area-element__service'>
                        <div className='bold'>主に利用するサービス</div>
                        <br />
                        <div className='logo-title--tyousei' />
                      </div>
                      <div className='button-area-element__submit'>
                        <button
                          className='btn-fixedsize'
                          onClick={e => {
                            this.props.dialog.callback.new(e);
                          }}
                        >
                          職長新規登録
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='dialog__footer dialog__footer--horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={e => {
              this.props.dialog.callback.back(e);
            }}
          >
            {messageUtility.getMessage('I-000-017')}
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 類似会社ダイアログ
 */
export class SimilerPartnerCompany extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__body text-center'>
          よく似た以下の会社がすでに登録されていますが、
          <br />
          登録を行いますか？
        </div>
        <div className='dialog-md__body'>
          <div className='dialog-form__scroll'>
            {_.map(this.props.dialog.callback.data, (company, index) => (
              <div key={index} className='dialog-form__similar'>
                <div className='dialog-form'>
                  <li className='dialog-form__item'>
                    <p>{company.name}</p>
                  </li>
                  <li className='dialog-form__item'>
                    <p>{`〒${company.company_branch.postal_code} ${company.company_branch.address}`}</p>
                  </li>
                  <li className='dialog-form__item'>
                    <p>{`電話番号: ${company.company_branch.tel}`}</p>
                  </li>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--negative'
            onClick={() => {
              this.props.dialog.callback.submit();
            }}
          >
            登録する
          </button>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => dialogLoader.close()}
          >
            キャンセル
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 協力会社管理者招待 ダイアログ
 * 画面遷移
 *  1.  施工体系図>>協力会社BOX>>確認・編集>>新規作成>>管理者招待
 */
export class PartnerUserInviteMail extends React.Component {
  constructor(props) {
    super(props);
    const forwardState = props.dialog.state;
    if (forwardState.partnerCompanyBranchBlockFlag) {
      this.initPartnerCompanyBranchId = HEAD_OFFICE_OPTION.id;
      this.partnerCompanyBranchPreviewName = HEAD_OFFICE_OPTION.name;
    } else {
      this.initPartnerCompanyBranchId =
        forwardState.partner_company_branch_id || HEAD_OFFICE_OPTION.id;
      this.partnerCompanyBranchPreviewName =
        forwardState.partnerCompanyBranchName || HEAD_OFFICE_OPTION.name;
    }
    this.state = {
      companies: [],
      selected: null,
      errorMessage: '',
      showRegisteredCompanies: false,
      showConfirmExistedEmailDialog: false,
      showConfirmIntegrateUserDialog: false,
      showIntegrateError: false,
      showInformationModal: false,
      integrateSuccessModal: null,
      integrateErrorMessage: null,
      listIntegrateUsers: null,
      values: {
        partner_company_branch_id: this.initPartnerCompanyBranchId,
        name_sei: '',
        name_mei: '',
        kana_sei: '',
        kana_mei: '',
        email: '',
      },
      validate: {
        invalid: false,
        messages: {
          name_sei: '',
        },
      },
    };
    this.schema;
    this.dialog = null;
    this.userId = LocalStorageService.getUserId();
    this.roleId = LocalStorageService.getRoleId();
    this.ownerCompanyId = Number(SessionStorageService.getCompanyId());
    this.companyId = Number(forwardState.companyId);
    this.companyBranchId = forwardState.companyBranchId;
    this.isCheckCompanyId = this.ownerCompanyId === this.companyId;
    this.isTargetRoleId = isPartnerCompanyRoleId(this.roleId);
  }

  getRegisteredCompanies = values => {
    const companyId = this.props.dialog.state.companyId;
    const params = {
      company_id: companyId,
      email: values.email,
    };

    return CompanyService.getRegisteredCompanies(companyId, params).then(
      async response => {
        if (response.result && _.has(response, 'data.entities.companies')) {
          const { companies } = response.data.entities;
          return companies;
        } else {
          // 失敗
          const errorMessage = _.get(response, 'data.message');
          const res = await LoginUserGroupsService.checkDuplicateEmail({
            email: values.email,
            user_role_code: USER_ROLES.partner.id,
            company_id: this.companyId,
            company_branch_id: this.companyBranchId,
          });
          if (res.result) {
            this.setState({
              showConfirmExistedEmailDialog: true,
              errorMessage: '',
            });
          } else {
            this.setState({
              showInformationModal: true,
              errorMessage,
            });
          }
          return [];
        }
      }
    );
  };

  handleChange = event => {
    deleteControlCodeFromEvent(event);
    this.setState({
      values: {
        ...this.state.values,
        [event.target.name]: event.target.value,
      },
    });
  };

  validate = event => {
    this.schema = Joi.object().keys({
      name_sei: Joi.string()
        .required()
        .max(64),
      name_mei: Joi.string()
        .required()
        .max(64),
      kana_sei: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(128),
      kana_mei: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(128),
      email: Joi.string()
        .regex(regex.pattern.email)
        .required(),
    });

    let eventKey = event ? event.target.name : null;
    let values = event
      ? { [eventKey]: this.refs[eventKey].value }
      : _.cloneDeep(this.state.values);

    const result = validateByJoi(this.schema, values);

    let hasErrMessage = false;
    if (result.messages) {
      const { messages } = _.cloneDeep(this.state.validate);
      if (event) {
        // 1件のみバリデーションする
        if (_.has(result.messages, eventKey)) {
          this.setState({
            validate: {
              invalid: true,
              messages: {
                ...messages,
                [eventKey]: result.messages[eventKey],
              },
            },
          });
          hasErrMessage = true;
        } else {
          if (_.has(messages, eventKey)) {
            const newMessages = _.omit(messages, eventKey);
            const invalid = !_.isEmpty(newMessages);
            this.setState({
              validate: {
                invalid,
                messages: newMessages,
              },
            });
            hasErrMessage = invalid;
          }
        }
      } else {
        hasErrMessage = true;
        this.setState({
          validate: {
            invalid: true,
            messages: result.messages,
          },
        });
      }
    } else {
      hasErrMessage = false;
      this.setState({
        validate: {
          invalid: false,
          messages: {},
        },
      });
    }

    return !hasErrMessage;
  };

  /**
   * 登録
   * @param {object} event // input
   */
  Submit = async () => {
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;
    const { values } = this.state;

    if (this.validate() === true) {
      const companies = await this.getRegisteredCompanies(values);
      if (
        this.state.showConfirmExistedEmailDialog ||
        this.state.showInformationModal
      ) {
        // メールアドレスの重複などでエラーになる場合止める
        this.updatingFlag = false;
        return;
      }
      if (_.isEmpty(companies)) {
        this.props.dialog.callback.submit(values);
      } else {
        this.setState({
          companies,
          showRegisteredCompanies: true,
          values,
        });
      }
    }
    this.updatingFlag = false;
  };

  handlePartnerCompanyBranchDropdownChange = async id => {
    const companyBranchData = await this.getPartnerCompanyBranch(id);
    if (companyBranchData) {
      this.partnerCompanyBranchPreviewName = _.toString(companyBranchData.name);
    } else {
      this.partnerCompanyBranchPreviewName = HEAD_OFFICE_OPTION.name;
    }
    this.setState({
      values: {
        ...this.state.values,
        partner_company_branch_id: id,
      },
    });
  };

  getPartnerCompanyBranch = async id => {
    if (Number(id)) {
      const { data } = await PartnerCompanyBranchService.show(
        this.props.dialog.state.companyId,
        Number(id)
      );
      return _.get(data, 'entities.partner_company_branch');
    }
  };

  closeDialog = stateName => {
    this.setState({ [stateName]: false });
    if (
      stateName === 'showInformationModal' &&
      this.state.integrateSuccessModal
    ) {
      this.props.dialog.callback.submitSuccess();
    }
  };

  confirmIntegrate = () => {
    if (this.updatingFlag) {
      return;
    }
    const { values } = this.state;
    this.updatingFlag = true;
    LoginUserGroupsService.checkIntegrate({
      email: values.email,
      user_role_code: USER_ROLES.partner.id,
      company_id: this.companyId,
      company_branch_id: this.companyBranchId,
    })
      .then(res => {
        if (res.result) {
          this.setState({
            listIntegrateUsers: _.get(res, 'data.entities.users'),
            showConfirmExistedEmailDialog: false,
            showConfirmIntegrateUserDialog: true,
          });
        } else {
          this.setState({
            integrateErrorMessage:
              _.get(res, 'data.message') ||
              messageUtility.getMessage('E-000-001'),
            showConfirmExistedEmailDialog: false,
            showIntegrateError: true,
          });
        }
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  confirmIntegrateUser = () => {
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;
    this.props.dialog.callback
      .submitIntegrateUser(this.state.values)
      .then(result => {
        let integrateSuccessModal = null;
        if (result) {
          EventManager.trigger(EventType.REFRESH_PROFILE);
          integrateSuccessModal = {
            title: INTEGRATE_USER_SUCCESS_TITLE,
            message: INTEGRATE_USER_SUCCESS_MESSAGE,
          };
        }
        this.setState({
          showInformationModal: true,
          integrateSuccessModal,
          errorMessage: integrateSuccessModal
            ? ''
            : INTEGRATE_USER_COMMON_ERROR_MESSAGE,
        });
      })
      .finally(() => {
        this.closeDialog('showConfirmIntegrateUserDialog');
        this.updatingFlag = false;
      });
  };

  render() {
    const renderRegisteredCompanies = () => (
      <React.Fragment>
        <div className='dialog__header'>
          <span className='dialog__title'>登録内容を確認してください</span>
        </div>
        <div className='dialog__body '>
          <div className='dialog-form dialog__text dialog__text--align-left'>
            <div className='dialog__row'>
              <p className='dialog__text-box dialog__text'>
                {messageUtility.getMessage('I-000-150')}{' '}
                <span className='dialog__text dialog__text--large'>
                  {_.get(_.head(this.state.companies), 'user_name') || ''}
                </span>
                {messageUtility.getMessage('I-000-151')}
              </p>
            </div>
            <div className='dialog__row'>
              <ul>
                {_.map(_.slice(this.state.companies, 0, 5), company => {
                  // すでに所属している会社がある場合は、ここにリストを最大5件表示
                  return (
                    <li
                      className='dialog__text dialog__text--large'
                      key={company.id}
                    >
                      <span className='dialog__text_company__row'>
                        {company.name}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className='dialog__row'>
              <p className='dialog__text-box dialog__text'>
                <span className='dialog__text dialog__text--large'>
                  {_.get(_.head(this.state.companies), 'user_name') || ''}
                </span>
                {messageUtility.getMessage('I-000-152')}
              </p>
              <span className='dialog__text-box dialog__text dialog__text--large text--red--primary dialog__text_company__row'>
                {this.props.dialog.state.companyName}
              </span>
              <p className='dialog__text-box dialog__text text--red--primary dialog__text_company__row'>
                {this.props.dialog.state.oneMasterTypeNameCompanyNumber}
                <br />
                {this.props.dialog.state.companyAddress}
              </p>
              <p className='dialog__text-box dialog__text'>
                {messageUtility.getMessage('I-000-153')}
              </p>
            </div>
          </div>
        </div>
        <div className='dialog__footer dialog__footer--horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              this.setState({ showRegisteredCompanies: false }, () => {
                this.props.dialog.callback.back();
              });
            }}
          >
            {messageUtility.getMessage('I-000-017')}
          </button>
          <button
            className='btn-fixedsize--effective'
            onClick={() => {
              this.props.dialog.callback.submit(this.state.values, {
                throughFlag: true,
              });
            }}
          >
            {messageUtility.getMessage('I-000-154')}
          </button>
        </div>
      </React.Fragment>
    );

    const readOnly = this.props.dialog.state.readOnly;
    const renderInviteForm = (values, messages) => (
      <React.Fragment>
        <div className='dialog__header'>
          <span className='dialog__title'>協力会社管理者招待</span>
        </div>
        <div className='dialog__body'>
          <div className='dialog__row dialog__text'>
            {!readOnly && (
              <Description type='primary'>
                <React.Fragment>
                  {messageUtility.getMessage('I-000-155')}
                  <br />
                  {messageUtility.getMessage('I-000-157')}
                </React.Fragment>
              </Description>
            )}
            {readOnly && (
              <Description type='primary'>
                <React.Fragment>
                  {messageUtility.getMessage('I-000-156')}
                  <br />
                  {messageUtility.getMessage('I-000-157')}
                </React.Fragment>
              </Description>
            )}
          </div>
          <div className='InviteForm input--autofill-overwrite'>
            <FormList>
              <FormListItem label='会社名'>
                <FormElement>
                  <p>{this.props.dialog.state.companyName}</p>
                </FormElement>
              </FormListItem>
              <FormListItem label='住所'>
                <FormElement>
                  <p>{this.props.dialog.state.companyAddress}</p>
                </FormElement>
              </FormListItem>
              {this.isTargetRoleId &&
                this.props.dialog.state.isManagerPermission &&
                this.isCheckCompanyId && (
                  <FormListItem label='支店' required={!readOnly}>
                    <FormElement
                      info={
                        readOnly
                          ? ''
                          : this.initPartnerCompanyBranchId ===
                            HEAD_OFFICE_OPTION.id
                          ? '支店はデフォルトで本社が選択されています。'
                          : '現場体制に追加された支店がデフォルトで選択されています。'
                      }
                    >
                      <PartnerCompanyBranchDropdown
                        disabled={readOnly}
                        selectedCompanyId={this.props.dialog.state.companyId}
                        selectedPartnerCompanyBranchId={
                          this.state.values.partner_company_branch_id
                        }
                        onSelect={this.handlePartnerCompanyBranchDropdownChange}
                        fixedOptions={[HEAD_OFFICE_OPTION]}
                        params={{ call_from: CALL_FROM_PAGE.FIELD_TREE_PAGE }}
                        previewValue={this.partnerCompanyBranchPreviewName}
                      />
                    </FormElement>
                  </FormListItem>
                )}
              <FormListItem label='姓' required={!readOnly}>
                <FormElement validate={messages.name_sei}>
                  <input
                    disabled={readOnly}
                    onBlur={event => this.validate(event)}
                    onChange={this.handleChange}
                    value={values.name_sei}
                    type='text'
                    ref='name_sei'
                    name='name_sei'
                    maxLength='64'
                  />
                </FormElement>
              </FormListItem>
              <FormListItem label='名' required={!readOnly}>
                <FormElement validate={messages.name_mei}>
                  <input
                    disabled={readOnly}
                    onBlur={event => this.validate(event)}
                    onChange={this.handleChange}
                    value={this.state.values.name_mei}
                    type='text'
                    ref='name_mei'
                    name='name_mei'
                    maxLength='64'
                  />
                </FormElement>
              </FormListItem>
              <FormListItem label='せい' required={!readOnly}>
                <FormElement validate={messages.kana_sei}>
                  <input
                    disabled={readOnly}
                    onBlur={event => this.validate(event)}
                    onChange={this.handleChange}
                    value={this.state.values.kana_sei}
                    type='text'
                    ref='kana_sei'
                    name='kana_sei'
                  />
                </FormElement>
              </FormListItem>
              <FormListItem label='めい' required={!readOnly}>
                <FormElement validate={messages.kana_mei}>
                  <input
                    disabled={readOnly}
                    onBlur={event => this.validate(event)}
                    onChange={this.handleChange}
                    value={this.state.values.kana_mei}
                    type='text'
                    ref='kana_mei'
                    name='kana_mei'
                  />
                </FormElement>
              </FormListItem>
              <FormListItem label='メールアドレス' required={!readOnly}>
                <FormElement validate={messages.email}>
                  <input
                    disabled={readOnly}
                    className='form-list__input-large'
                    onBlur={event => this.validate(event)}
                    onChange={this.handleChange}
                    value={this.state.values.email}
                    type='text'
                    ref='email'
                    name='email'
                  />
                </FormElement>
              </FormListItem>
            </FormList>
          </div>
        </div>
        <div className='dialog__footer dialog__footer--horizontal'>
          {!readOnly && (
            <React.Fragment>
              <button
                className='btn-fixedsize--sub'
                onClick={() => {
                  this.props.dialog.callback.back();
                }}
              >
                {messageUtility.getMessage('I-000-017')}
              </button>
              <button
                className='btn-fixedsize'
                onClick={() => {
                  this.Submit();
                }}
              >
                管理者招待
              </button>
            </React.Fragment>
          )}
          {readOnly && (
            <React.Fragment>
              <button
                className='btn-fixedsize--sub'
                onClick={() => {
                  this.props.dialog.callback.cancel();
                }}
              >
                {messageUtility.getMessage('I-000-147')}
              </button>
              <button
                className='btn-fixedsize--effective'
                onClick={() => {
                  this.props.dialog.callback.confirm();
                }}
              >
                {messageUtility.getMessage('I-000-148')}
              </button>
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );

    return (
      <div
        ref={e => {
          this.dialog = e;
        }}
        className='dialog dialog--wide dialog--modal dialog--dialog-partner-user-invite-mail'
      >
        {this.state.showRegisteredCompanies
          ? renderRegisteredCompanies()
          : renderInviteForm(this.state.values, this.state.validate.messages)}
        <Information
          title={messageUtility.getMessage('E-001-402')}
          message={this.state.errorMessage}
          {...this.state.integrateSuccessModal}
          visible={this.state.showInformationModal}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.closeDialog('showInformationModal')}
          multilineText={true}
        />
        <ConfirmExistedEmailDialog
          visible={this.state.showConfirmExistedEmailDialog}
          onCancel={() => this.closeDialog('showConfirmExistedEmailDialog')}
          onConfirmIntegrate={this.confirmIntegrate}
        />
        <ConfirmIntegrateUserDialog
          visible={this.state.showConfirmIntegrateUserDialog}
          onConfirm={this.confirmIntegrateUser}
          data={this.state.listIntegrateUsers}
          onCancel={() => this.closeDialog('showConfirmIntegrateUserDialog')}
        />
        <IntegrateError
          visible={this.state.showIntegrateError}
          reason={this.state.integrateErrorMessage}
          onCancel={() => this.closeDialog('showIntegrateError')}
        />
      </div>
    );
  }
}

export const AddPartnerCompanyFieldTreeSuccessDialog = props => {
  const { companyName, onConfirm, onCancel } = props.dialog || {};
  return (
    <Confirmation
      rootClassName={addPartnerCompanySucessDialog}
      visible={true}
      title='協力会社の追加完了'
      message={messageUtility.getMessage('I-000-136', companyName)}
      onConfirm={onConfirm}
      onCancel={onCancel}
      multilineText={true}
      effectiveButtonClassName='btn'
      confirmButtonText='管理者・職長を招待する'
      cancelButtonText='現場体制に戻る'
    />
  );
};

export const DupulicateCompanyDialog = props => {
  const { companyNumber, onClose } = props.dialog || {};
  return (
    <Information
      visible={true}
      onClose={onClose}
      title={'協力会社登録済'}
      message={`選択した協力会社が既にBuildeeに登録されています。\nお手数ですが下記の法人番号で再度検索を実施し登録操作を実施してください。\n\n${companyNumber}`}
      buttonText={messageUtility.getMessage('I-000-017')}
      multilineText={true}
    />
  );
};

export const FieldTreeUpdateFinishFlagFailure = props => {
  const { callback, title = messageUtility.getMessage('E-001-402'), message } =
    props.dialog || {};
  return (
    <Information
      visible={true}
      onClose={callback.done}
      title={title}
      message={message || messageUtility.getMessage('E-000-055')}
      buttonText={messageUtility.getMessage('I-000-017')}
      multilineText={true}
    />
  );
};

export const ChangeMyStatusDialog = ({
  dialog: {
    callback: { onCancel, onConfirm },
  },
}) => {
  const renderMsg = () => {
    return (
      <React.Fragment>
        <div className='description'>
          <span>
            自身のアカウントを作業終了しようとしています。作業終了すると現場へのアクセスが制限されます。
          </span>
          <br />
          <span>
            アクセス制限を解除する場合は、他のユーザーに稼働中に変更してもらう必要があります。
          </span>
          <br />
        </div>
        本当に作業終了してよろしいですか？
      </React.Fragment>
    );
  };
  return (
    <Confirmation
      visible={true}
      title='作業終了しますか？'
      message={renderMsg()}
      rootClassName='ChangeMyStatusDialog'
      onConfirm={onConfirm}
      onCancel={onCancel}
      multilineText={true}
      confirmButtonText='作業終了する'
      cancelButtonText={messageUtility.getMessage('I-000-008')}
    />
  );
};

export const BuildeeUserDialog = ({
  dialog: {
    callback: { onCancel, onConfirm },
  },
}) => {
  const renderMsg = () => {
    return (
      <React.Fragment>
        <span>
          このユーザーは現場のBuildee担当者に設定されています。
          <br />
          このまま作業終了にするとBuildee担当者が現場にアクセスできなくなります。
          <br /> <br />
        </span>
        <span>
          現場情報でBuildee担当者を変更してから作業終了にすることを推奨します。
          <br /> <br />
        </span>
        <span>本当に作業終了に変更してもよろしいですか？</span>
      </React.Fragment>
    );
  };
  return (
    <Confirmation
      visible={true}
      title='作業終了しますか？'
      message={renderMsg()}
      onCancel={onCancel}
      onConfirm={onConfirm}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      confirmButtonText='作業終了する'
      multilineText={true}
    />
  );
};

export const AdminOfJVDialog = ({
  dialog: {
    callback: { onClose },
  },
}) => {
  const renderMsg = () => {
    return '現場を管理している支店に所属する支店管理者は作業終了に変更できません。';
  };
  return (
    <Information
      visible={true}
      title='作業終了できません'
      message={renderMsg()}
      onClose={onClose}
      multilineText={true}
      buttonText={messageUtility.getMessage('I-000-017')}
    />
  );
};

export const ExistRelativeDataDialog = ({
  dialog: {
    afterBlockDate,
    callback: { onCancel, onConfirm },
  },
}) => {
  const renderContent = () => {
    return (
      <React.Fragment>
        <p>
          このユーザーは{afterBlockDate}
          以降の安全当番もしくは各種予定の元請担当者に設定されています。
          <br />
          このまま作業終了を行うと、{afterBlockDate}
          以降の安全当番・元請担当者の設定はクリアされます。以下の画面をご確認のうえ操作してください。
        </p>
        <div className='detail'>
          <ul className='detail__list'>
            <li className='detail__item'>
              安全当番：作業予定一覧 / 作業実績一覧 画面
            </li>
            <li className='detail__item'>
              元請担当者：作業予定一覧 / 作業実績一覧 / ゲート予定 / 揚重機予定
              / 機材予定 画面
            </li>
          </ul>
        </div>
        <p>本当に作業終了してよろしいですか？</p>
      </React.Fragment>
    );
  };
  return (
    <Confirmation
      visible={true}
      title='作業終了しますか？'
      message={renderContent()}
      rootClassName='dialog--wide UsingDataDialog'
      confirmButtonText='作業終了する'
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      onCancel={onCancel}
      onConfirm={onConfirm}
      multilineText={true}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/FieldTreeDialog.jsx